import React, { createContext, useContext } from "react";
var GatsbyMDXScopeContext = /*#__PURE__*/createContext({});
export var useMDXScope = function useMDXScope(scope) {
  var contextScope = useContext(GatsbyMDXScopeContext);
  return scope || contextScope;
};

if (typeof useMDXScope !== 'undefined' && useMDXScope && useMDXScope === Object(useMDXScope) && Object.isExtensible(useMDXScope) && !useMDXScope.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useMDXScope, '__filemeta', {
    configurable: true,
    value: {
      name: "useMDXScope",
      filename: "node_modules/gatsby-plugin-mdx/context.js"
    }
  });
}

export var MDXScopeProvider = function MDXScopeProvider(_ref) {
  var __mdxScope = _ref.__mdxScope,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(GatsbyMDXScopeContext.Provider, {
    value: __mdxScope
  }, children);
};

if (typeof MDXScopeProvider !== 'undefined' && MDXScopeProvider && MDXScopeProvider === Object(MDXScopeProvider) && Object.isExtensible(MDXScopeProvider) && !MDXScopeProvider.hasOwnProperty('__filemeta')) {
  Object.defineProperty(MDXScopeProvider, '__filemeta', {
    configurable: true,
    value: {
      name: "MDXScopeProvider",
      filename: "node_modules/gatsby-plugin-mdx/context.js"
    }
  });
}